import React from 'react';
// Vérifiez que le fichier JSON est bien à cet emplacement
import Title from '../../components/Title/Title';
import SimpleTitle from '../../components/Title/SimpleTitle';
import Content from '../../components/content/content';
import ContentSlider from '../../components/content/content-slider.jsx';
import ContentText from '../../components/content/content-text.jsx';


// Vérifiez que le composant Skills est bien à cet emplacement
import Skills from '../../components/Projects/Skills.jsx';
import portfolio from '../../assets/content/projets/portfolio.json';

const Portfolio = () => {
    return (
        <div className='projet'>
            <div class="bloc">
                <Title title={portfolio.title} variant={portfolio.variant} />
                <ContentText content={portfolio.description} />


                <div className='content'>
                    <SimpleTitle title="Ma démarche" variant="green" position="left" />
                    <ContentSlider content={portfolio.partie1} images={portfolio.slider1} cote={"left"}></ContentSlider>   
                    <ContentSlider content={portfolio.partie2} images={portfolio.slider2} cote={"right"}></ContentSlider>

                    <ContentSlider content={portfolio.partie3} images={portfolio.slider3} cote={"left"}></ContentSlider>
                </div>
            </div>

            <div className='skills bloc'>
                <SimpleTitle title="Technologies utilisées" variant="white" position="left" />
                <div className='skills-grid'>
                    {portfolio.technologies.map((tech, index) => (
                    <Skills
                        image={tech.image}
                        alt={tech.alt}
                        competence={tech.name}
                        centered={tech.bool}
                    />
                ))}
                </div>
            </div>
            <div className='competences bloc'>
                <SimpleTitle title="Compétences et apprentissages critiques mobilisés" variant="purple" position="left" />
                <Content content={portfolio.competences} image={{thumb: portfolio.imgcompetences,hd: portfolio.imgcompetencesgrd}} alt={portfolio.altcompetences} cote={"left"} width={portfolio.widthcompetences} height={portfolio.heightcompetences} title="Illustration des compétences" ></Content>
            </div>
            
        </div>
    );
};

export default Portfolio;